import React from 'react';
import { ImageEntity } from '@fupa/fupa-uikit';
import MainNewsImage from 'app/components/topNewsModule/mainNews/MainNewsImage';
import { PublishDate, Subject, TextOverlay, Title, Wrapper } from 'app/components/topNewsModule/mainNews/mainNewsStyles';
export default function MainNews(_ref) {
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    to: data.getLink(),
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MainNews",
    "data-sentry-source-file": "MainNews.tsx"
  }, /*#__PURE__*/React.createElement(MainNewsImage, {
    imageEntity: ImageEntity.News,
    image: data.news.image,
    "data-sentry-element": "MainNewsImage",
    "data-sentry-source-file": "MainNews.tsx"
  }), /*#__PURE__*/React.createElement(TextOverlay, {
    "data-sentry-element": "TextOverlay",
    "data-sentry-source-file": "MainNews.tsx"
  }, /*#__PURE__*/React.createElement(Subject, {
    "data-sentry-element": "Subject",
    "data-sentry-source-file": "MainNews.tsx"
  }, data.subject), /*#__PURE__*/React.createElement(Title, {
    "data-sentry-element": "Title",
    "data-sentry-source-file": "MainNews.tsx"
  }, data.news.title), /*#__PURE__*/React.createElement(PublishDate, {
    "data-sentry-element": "PublishDate",
    "data-sentry-source-file": "MainNews.tsx"
  }, data.formatDateRelative())));
}